export default "__VITE_ASSET__CO26_jXU__"